import React from 'react';
import { Tabs, TextInput } from '@gravity-ui/uikit';
import { cn } from '../classname';
import { i18n } from '../i18n/forms';
import { isFunction } from '../lodash';
import { TextInputFixed } from './TextInput';
import Form from './base';
import { ButtonAttach, NumberInput } from './components';
import { enterKeyHandler } from './utils';
import './ImageForm.css';
const b = cn('image-form');
export const ImageForm = ({ className, autoFocus, onCancel, onSubmit, onAttach, loading, }) => {
    const [tabId, setTabId] = React.useState(() => isFunction(onAttach) ? "attach" /* ImageTabId.Attach */ : "link" /* ImageTabId.Link */);
    const [url, setUrl] = React.useState('');
    const [name, setName] = React.useState('');
    const [alt, setAlt] = React.useState('');
    const [width, setWidth] = React.useState();
    const [height, setHeight] = React.useState();
    const shouldRenderTabs = isFunction(onAttach);
    React.useLayoutEffect(() => {
        if (!shouldRenderTabs && tabId === "attach" /* ImageTabId.Attach */) {
            setTabId("link" /* ImageTabId.Link */);
        }
    }, [shouldRenderTabs, tabId]);
    const handleSubmit = () => {
        const data = {
            url: url.trim(),
            name: name.trim(),
            alt: alt.trim(),
        };
        if (typeof width === 'number' && width >= 0)
            data.width = width;
        if (typeof height === 'number' && height >= 0)
            data.height = height;
        onSubmit(data);
    };
    const inputEnterKeyHandler = enterKeyHandler(handleSubmit);
    return (React.createElement(Form.Form, { className: b(null, [className]) },
        shouldRenderTabs && (React.createElement(Tabs, { activeTab: tabId, onSelectTab: setTabId, items: [
                { id: "attach" /* ImageTabId.Attach */, title: i18n('common_tab_attach') },
                { id: "link" /* ImageTabId.Link */, title: i18n('common_tab_link') },
            ] })),
        tabId === "attach" /* ImageTabId.Attach */ && onAttach && (React.createElement(React.Fragment, null,
            React.createElement(Form.Layout, null, i18n('image_upload_help')),
            React.createElement(Form.Footer, { onCancel: onCancel },
                React.createElement(ButtonAttach, { multiple: true, accept: "image/*", onUpdate: onAttach, buttonProps: { size: 's', view: 'action', loading } }, i18n('common_action_upload'))))),
        tabId === "link" /* ImageTabId.Link */ && (React.createElement(React.Fragment, null,
            React.createElement(Form.Layout, null,
                React.createElement(Form.Row, { label: i18n('common_link'), control: React.createElement(TextInputFixed, { size: "s", view: "normal", value: url, onUpdate: setUrl, placeholder: "https://", autoFocus: autoFocus, className: b('input', { type: 'link' }), onKeyPress: inputEnterKeyHandler }) }),
                React.createElement(Form.Row, { label: i18n('image_name'), control: React.createElement(TextInput, { size: "s", view: "normal", value: name, onUpdate: setName, className: b('input', { type: 'name' }), onKeyPress: inputEnterKeyHandler }) }),
                React.createElement(Form.Row, { label: i18n('image_alt'), help: i18n('image_alt_help'), control: React.createElement(TextInput, { size: "s", view: "normal", value: alt, onUpdate: setAlt, className: b('input', { type: 'alt' }), onKeyPress: inputEnterKeyHandler }) }),
                React.createElement(Form.Row, { label: i18n('common_sizes'), control: React.createElement("div", { className: b('size-controls') },
                        React.createElement(NumberInput, { min: 0, size: "s", view: "normal", value: width, onUpdate: setWidth, placeholder: i18n('image_size_width'), className: b('input', { type: 'width' }), onKeyDown: inputEnterKeyHandler }),
                        "x",
                        React.createElement(NumberInput, { min: 0, size: "s", view: "normal", value: height, onUpdate: setHeight, placeholder: i18n('image_size_height'), className: b('input', { type: 'height' }), onKeyDown: inputEnterKeyHandler })) })),
            React.createElement(Form.Footer, { onCancel: onCancel, onSubmit: handleSubmit })))));
};
